import { render, staticRenderFns } from "./JSelectModelPoints.vue?vue&type=template&id=0351c837&scoped=true&"
import script from "./JSelectModelPoints.vue?vue&type=script&lang=js&"
export * from "./JSelectModelPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0351c837",
  null
  
)

export default component.exports